import React from 'react';
import Layout from '../Layout';
import { Image } from 'react-bootstrap';
import './css/about.css'

const About = () => {
    return (
        <Layout>

            <section className='abt-container'>
                <div className='abt-header'>
                    <Image src="/about2.webp" className="d-inline-block  img-fluid wow fadeInDown" data-wow-duration="0.5s" alt="inovative" />

                    <div className='header-content'>
                        <h1 className='wow animate__animated animate__fadeInUp' data-wow-duration='1s'>Who We Are</h1>
                        <p className='wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>We continuously seek innovative ways to enhance<br className='hide'/> our service offerings and operational efficiency.</p>
                    </div>

                </div>
            </section>

            <section className='child-container'>
                <h1 className='wow animate__animated animate__fadeInUp' data-wow-duration='1s'>Divs Global Services Limited, established in 2020, is a trusted and dynamic provider of innovative, cost- effective and reliable solutions across multiple industries.</h1>
            </section>

            <section className='info-container'>
                <section className="info‑section">
                    <div className="image-wrapper">
                        <Image src={"/about1.webp"} alt="worker" className='background-image wow animate__animated animate__fadeInUp' data-wow-duration='1.8s' />
                        <div className="text-box">

                            <div className='lineTwo' />
                            <div>
                                <p className='wow animate__animated animate__fadeInUp' data-wow-duration='1s'>We specialize in environment and safety solutions, civil works, mechanical works, metal fabrication, general procurement, and consultancy services.</p>
                                <p className='wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>With extensive expertise, we are committed to meeting the diverse needs of our clients while maintaining the highest industry standards.</p>
                            </div>
                        </div>
                    </div>
                </section>

            </section>


            <section className='child-container'>

                <div className=''>
                    <h1 className='wow animate__animated animate__fadeInUp' data-wow-duration='1s'>Vision Statement</h1>
                    <p className='pgText wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>To be a trusted industry leader in delivering innovative, safe and sustainable solutions across multiple sectors, including the energy industries, driven by excellence, integrity, and professionalism to ensure customer satisfaction.</p>
                </div>

                <div className='visMis'>
                    <Image src="/missviss.jpg" className='d-inline-block  img-fluid wow animate__animated animate__fadeInUp' data-wow-duration="1.5s" alt="inovative" />
                </div>


                <div className=''>
                    <h1 className='wow animate__animated animate__fadeInUp' data-wow-duration='1s'>Mission Statement</h1>
                    <p className='pgText wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>We strive to build long-term relationships through transparent business practices, cutting-edge solutions, and a dedication to safety and sustainability, ensuring value for our clients, employees, and the environment.</p>
                </div>

            </section>



            <section className='sectionThree'>
                <div className='child-container'>
                    <div className='sectionInner'>
                        <div className='secThreeOne'>
                        </div>
                        <div className='secThreeTwo'>
                            <h1 className='wow animate__animated animate__fadeInUp' data-wow-duration="0.8s">WHY CHOOSE US?</h1>
                            <p className='paragText wow animate__animated animate__fadeInUp' data-wow-duration='1.2s'>The company is committed to delivering high-quality, reliable, and cost-effective services to ensure operational efficiency and workplace safety in the energy sector.</p>

                        </div>
                    </div>







                    <div className='sectionInnerTwo'>
                        <div className='list-box wow animate__animated animate__fadeInUp' data-wow-duration='1s'>
                            <div className='position'>
                                <h4 className='box-title wow animate__animated animate__fadeInUp' data-wow-duration='1.2s'>Expertise & Experience</h4>
                                <div className='d-flex gap-2'>
                                    <div className='w30'>
                                        <h1 className='number wow animate__animated animate__fadeInUp' data-wow-duration='2s'>01</h1>
                                    </div>
                                    <div className='w80'>
                                        <p className='box-paragraph-title wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>A highly skilled team with years of industry experience.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='list-box wow animate__animated animate__fadeInUp'>
                            <div className='position'>
                                <h4 className='box-title wow animate__animated animate__fadeInUp' data-wow-duration='1.2s'>Quality & Innovation</h4>
                                <div className='d-flex gap-2'>
                                    <div className='w30'>
                                        <h1 className='number wow animate__animated animate__fadeInUp' data-wow-duration='2s'>02</h1>
                                    </div>
                                    <div className='w80'>
                                        <p className='box-paragraph-title wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>Commitment to delivering top-tier solutions with innovative approaches.</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>


                    <div className='sectionInnerTwo'>
                        <div className='list-box wow animate__animated animate__fadeInUp' data-wow-duration='1s'>
                            <div className='position'>
                                <h4 className='box-title wow animate__animated animate__fadeInUp' data-wow-duration='1.2s'>Integrity & Transparency</h4>
                                <div className='d-flex gap-2'>
                                    <div className='w30'>
                                        <h1 className='number wow animate__animated animate__fadeInUp' data-wow-duration='2s'>03</h1>
                                    </div>
                                    <div className='w80'>
                                        <p className='box-paragraph-title wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>Ethical business practices that build trust with clients and partners.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='list-box wow animate__animated animate__fadeInUp'>
                            <div className='position'>
                                <h4 className='box-title wow animate__animated animate__fadeInUp' data-wow-duration='1.2s'>Sustainability Focus</h4>
                                <div className='d-flex gap-2'>
                                    <div className='w30'>
                                        <h1 className='number wow animate__animated animate__fadeInUp' data-wow-duration='2s'>04</h1>
                                    </div>
                                    <div className='w80'>
                                        <p className='box-paragraph-title wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>Solutions designed with environmental responsibility in mind.</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>







                </div>
            </section>



        </Layout>
    );
};

export default About;